import React from 'react';
import SvgIcon from '../SvgIcon';

/**
 * @ignore - internal component.
 */
function ChevronRight(props) {
  return (
    <SvgIcon {...props}>
      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
    </SvgIcon>
  );
}

export default React.memo(ChevronRight);



// WEBPACK FOOTER //
// ./src/icons/internals/ChevronRight.jsx